angular.module('core')
  .directive('browserCheck', [function() {
    return {
      restrict: 'E',
      scope: {
        feature: '=?',
        checkSupport: '=checkSupport'
      },
      templateUrl: '/resources/core/partials/browser-check.html',
      controller: function($scope) {
        $scope.feature = angular.isDefined($scope.feature) ? $scope.feature : "This feature";
      }
    };
  }]);
